import { getLogger } from "@momentum/logger";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType,
} from "react-router";
import * as Sentry from "@sentry/react";
import { routes } from "#routes.ts";
import { configurei18Next, i18next } from "@momentum/i18n";
import { betslurpApiConfig } from "@momentum/betslurp-api";
import { amplifyClient } from "#amplifyClient.ts";


betslurpApiConfig.baseUrl = "/betslurp";
betslurpApiConfig.prepareHeaders = async (headers) => {
  const authSession = await amplifyClient.getAuthSession();
  if (authSession.tokens) {
    headers.set(
      "Authorization",
      `Bearer ${authSession.tokens.accessToken.toString()}`
    );
  }
  return headers;
};

configurei18Next();

i18next.changeLanguage('en-US')

Sentry.init({
  dsn: "https://d70d87c26170eafe29a64e29a61b26a3@o1398585.ingest.us.sentry.io/4510241068810240",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  // TODO: make domain dynamic based on environment
  tracePropagationTargets: ["localhost", "app-dev.react.live"],
  environment: import.meta.env.MODE,
});

const logger = getLogger();

logger.metadataOnly({
  mode: import.meta.env.MODE,
  build: import.meta.env.VITE_BUILD_NUMBER,
  version: import.meta.env.VITE_APP_VERSION,
});

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

const rootEl = document.getElementById("root")!;

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
